import type { StrapiLanding } from '~~/types/strapi'
import { useStrapi } from '#imports'

export async function useLandingPage() {
  const route = useRoute()
  const i18n = useI18n()
  const strapi = useStrapi()

  const params = computed(() => ({
    locale: i18n.locale.value,
    slug: route.params.slug as string,
  }))

  const { data: pageData } = await useAsyncData(
    `landing:${JSON.stringify(params.value)}`,
    () =>
      strapi.find<StrapiLanding>('landings', {
        filters: {
          slug: params.value.slug,
        },
        // temporarily shut down
        locale: params.value.locale,
        populate: {
          backgroundImage: {
            populate: '*',
          },
          heroImage: {
            populate: '*',
          },
          seo: {
            populate: '*',
          },
          featured_events: {
            populate: '*',
          },
          analytic: {
            populate: '*',
          },
        },
      })
  )

  if (!pageData?.value?.data[0]) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
  }

  return {
    pageData: computed(() => pageData.value?.data[0]!),
  }
}

export async function useLandingPages() {
  const route = useRoute()
  const i18n = useI18n()
  const strapi = useStrapi()

  const params = computed(() => ({
    locale: i18n.locale.value,
    page: Number(route.query.page) || 1,
    pageSize: Number(route.query.pageSize) || 100,
  }))

  const { data } = await useAsyncData(
    `landings:${JSON.stringify(params.value)}`,
    () =>
      strapi.find<StrapiLanding>('landings', {
        // temporarily shut down
        // locale: params.value.locale,
        populate: {
          backgroundImage: {
            populate: '*',
          },
          heroImage: {
            populate: '*',
          },
        },
        pagination: {
          page: Number(params.value.page),
          pageSize: Number(params.value.pageSize),
        },
        sort: ['updatedAt:desc', 'createdAt:desc'],
      })
  )

  return {
    data: computed(() => data?.value?.data || []),
    meta: computed(() => data?.value?.meta || {}),
  }
}
